import { colorsDashboard } from '../constants/defaultOptionsChart';

export function transformDataToSeries(
  data,
  categoriesTemp,
  options,
  sortingColumnName
) {
  if (!categoriesTemp) return null;

  const summaryTable = data;

  let tempData = [];

  Object.keys(categoriesTemp).forEach((key, keyMetric) => {
    const temp2 = {
      name: categoriesTemp[key].label,
      id: key,
      color: colorsDashboard?.[keyMetric + 1],
      keyMetric: keyMetric,
      data: [],
      type: 'spline'
    };

    Object.keys(summaryTable).forEach(date => {
      const summaryRow = summaryTable[date][key];
      temp2.data.push(summaryRow || null);
    });

    tempData.push(temp2);
  });

  tempData = tempData.filter(item => item.data.some(value => value !== null));

  if (sortingColumnName === 'total') {
    tempData = tempData?.sort((a, b) => {
      const sumA = Array.isArray(a.data)
        ? a.data.reduce((acc, val) => acc + (val ?? 0), 0)
        : 0;
      const sumB = Array.isArray(b.data)
        ? b.data.reduce((acc, val) => acc + (val ?? 0), 0)
        : 0;
      return sumB - sumA;
    });
  }

  const seriesData =
    tempData.length > 0
      ? [
          {
            name: 'Show/Hide',
            data: null,
            visible: false
          },
          ...tempData
        ]
      : [...tempData];

  const optionsTemp = {
    ...options,
    xAxis: {
      ...options.xAxis,
      categories: Object.keys(summaryTable)
    },

    series: [...seriesData]
  };

  return optionsTemp;
}

export function transformSeriesToPercentageStackedArea(options) {
  if (!options?.series) return options;

  const series = options.series.filter(item => item?.id);
  const pointCount = series.reduce(
    (count, item) => Math.max(count, item.data?.length || 0),
    0
  );
  const totals = Array.from({ length: pointCount }, (_, index) =>
    series.reduce((total, item) => {
      const value = Number(item.data?.[index]);
      return total + (Number.isFinite(value) && value > 0 ? value : 0);
    }, 0)
  );

  return {
    ...options,
    chart: {
      ...options.chart,
      type: 'area',
      isPercentageStacked: true
    },
    yAxis: {
      ...options.yAxis,
      min: 0,
      max: 100,
      labels: {
        ...options.yAxis?.labels,
        format: '{value}%'
      }
    },
    plotOptions: {
      ...options.plotOptions,
      area: {
        ...options.plotOptions?.area,
        stacking: 'percent'
      }
    },
    series: options.series.map(item => {
      if (!item?.id) return item;

      return {
        ...item,
        type: 'area',
        stack: 'ai-adoption',
        data: item.data.map((value, index) => {
          const numericValue = Number(value);
          const total = totals[index];

          if (!Number.isFinite(numericValue) || total === 0) return null;

          return Number(((Math.max(numericValue, 0) / total) * 100).toFixed(2));
        })
      };
    })
  };
}

export function transformDataToPie(summaryTable, categories, options) {
  if (!summaryTable) {
    return;
  }

  const dataTemp = Object.keys(summaryTable).reduce((acc, key) => {
    if (categories?.[key]?.label !== undefined) {
      const obj = {
        name: categories?.[key]?.label?.replace(/_/g, ' '),
        id: key,
        y: summaryTable[key]
      };

      acc.push(obj);
    }

    return acc;
  }, []);

  const optionsTemp = {
    ...options,

    series: [
      {
        name: 'Percentage',
        colorByPoint: true,
        data: dataTemp
      }
    ]
  };

  return optionsTemp;
}
